<template>
  <div class="ac2">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="container">
        <h1 class="page-title">行业资讯</h1>
        <p class="page-subtitle">深度解析电影产业动态与趋势</p>
        <div class="page-decoration"></div>
      </div>
    </div>

    <div class="container">
      <div class="content-wrapper">
        <!-- 左侧 -->
        <div class="a2-l">
          <!-- banner区块 -->
          <div class="a2-banner">
            <img src="/imgs/b2.jpg" alt="行业资讯" />
            <div class="banner-overlay">
              <h2>专业电影资讯平台</h2>
              <p>汇聚最新行业动态与深度分析</p>
            </div>
          </div>

          <!-- 资讯统计 -->
          <div class="stats-bar">
            <div class="stat-item">
              <i class="iconfont icon-article"></i>
              <span class="stat-number">{{ data.length }}+</span>
              <span class="stat-label">篇专业资讯</span>
            </div>
            <div class="stat-item">
              <i class="iconfont icon-eye"></i>
              <span class="stat-number">10万+</span>
              <span class="stat-label">每日阅读</span>
            </div>
            <div class="stat-item">
              <i class="iconfont icon-writer"></i>
              <span class="stat-number">50+</span>
              <span class="stat-label">专业作者</span>
            </div>
          </div>

          <!-- 循环项 -->
          <div class="a2-item" v-for="(item, index) in this.data" :key="index" @click="gopay()">
            <div class="item-card">
              <!-- 左侧图片 -->
              <div class="item-img">
                <img :src="item.img" alt="" />
                <div class="item-badge">
                  <span class="premium-tag">付费阅读</span>
                  <span class="price-tag">¥2</span>
                </div>
                <div class="item-overlay">
                  <button class="read-now-btn">立即阅读</button>
                </div>
              </div>
              
              <!-- 右侧信息 -->
              <div class="item-info">
                <!-- 标题 -->
                <div class="item-title">{{ item.title }}</div>
                
                <!-- 元信息 -->
                <div class="item-meta">
                  <span class="meta-item">
                    <i class="iconfont icon-time"></i>
                    {{ formatDate() }}
                  </span>
                  <span class="meta-item">
                    <i class="iconfont icon-zixun"></i>
                    {{ Math.floor(Math.random() * 1000) + 500 }} 阅读
                  </span>
                  <span class="meta-item">
                    <i class="iconfont icon-tag"></i>
                    行业资讯
                  </span>
                </div>

                <!-- 简介 -->
                <div class="item-jj">
                  {{ item.jj }}
                </div>

                <!-- 操作区域 -->
                <div class="item-actions">
                  <button class="pay-btn" @click.stop="gopay()">
                    <i class="iconfont icon-pay"></i>
                    付费阅读
                  </button>
                 
                </div>
              </div>
            </div>
          </div>

         
        </div>
        
        <!-- 右侧 -->
        <div class="a2-r">
          <!-- 热门文章 -->
          <div class="sidebar-card">
            <div class="card-header">
              <h3 class="card-title">
                <i class="iconfont icon-hot"></i>
                热门文章
              </h3>
              <div class="title-decoration"></div>
            </div>
            
            <div class="hot-list">
              <div class="hot-item" v-for="(item, index) in this.data2" :key="index" @click="gopay(item.id)">
                <div class="hot-rank">
                  <span class="rank-number" :class="{top3: index < 3}">{{ index + 1 }}</span>
                </div>
                <div class="hot-content">
                  <div class="hot-title">{{ item.title }}</div>
                  <div class="hot-meta">
                    <span class="hot-views">
                      <i class="iconfont icon-fire"></i>
                      {{ Math.floor(Math.random() * 1000) + 1000 }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 推荐标签 -->
          <div class="sidebar-card">
            <div class="card-header">
              <h3 class="card-title">
                <i class="iconfont icon-tags"></i>
                推荐标签
              </h3>
              <div class="title-decoration"></div>
            </div>
            
            <div class="tags-cloud">
              <span class="tag" v-for="tag in tags" :key="tag" :class="getTagClass(tag)">
                {{ tag }}
              </span>
            </div>
          </div>

          <!-- 订阅提醒 -->
          <div class="sidebar-card subscribe-card">
            <div class="subscribe-content">
              <i class="iconfont icon-bell subscribe-icon"></i>
              <h4 class="subscribe-title">订阅最新资讯</h4>
              <p class="subscribe-desc">第一时间获取行业动态与深度分析</p>
              <button class="subscribe-btn">
                <i class="iconfont icon-email"></i>
                立即订阅
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <modal title="请选择支付方式" btnType="1" modalType="middle" :showModal="showModal" @submit="showModal = false"
      @cancel="showModal = false">
      <template v-slot:body>
        <div class="payment-content">
          <div class="payment-header">
            <i class="iconfont icon-lock payment-lock"></i>
            <h3>付费阅读</h3>
          </div>
          <div class="payment-amount">
            <span class="amount-label">支付金额</span>
            <span class="amount-value">¥2.00</span>
          </div>
          <img src="/imgs/pay.png" class="payment-qr" />
          <div class="payment-methods">
            <div class="method-item active">
              <i class="iconfont icon-wechat"></i>
              <span>微信支付</span>
            </div>
          </div>
          <p class="payment-tip">扫码支付2元，即可阅读完整内容</p>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from "./../components/Modal";
export default {
  components: {
    Modal,
  },
  data() {
    return {
      data: [],
      data2: [],
      showModal: false,
      state: JSON.parse(window.localStorage.getItem("state")),
      tags: ['票房分析', '影视投资', '政策解读', '市场趋势', '技术前沿', '导演专访', '演员动态', '电影节', '流媒体', '国际合作']
    };
  },
  mounted() {
    this.init();
    this.init2();
    document.title = "首都电影院";
  },
  methods: {
    init() {
      this.axios.get("/mock/info.json").then((res) => {
        const data = res.data;
        this.data = data.splice(0, 8);
      });
    },
    init2() {
      this.axios.get("/mock/info.json").then((res) => {
        const data = res.data;
        this.data2 = data.splice(3, 10);
      });
    },
    formatDate() {
      const now = new Date();
      const month = now.getMonth() + 1;
      const day = now.getDate();
      return `${month}月${day}日`;
    },
    getTagClass(tag) {
        console.log(tag)
      const classes = ['tag-primary', 'tag-secondary', 'tag-success', 'tag-warning', 'tag-danger'];
      return classes[Math.floor(Math.random() * classes.length)];
    
    },
    // 跳转 逻辑 封装
    goDays(methods, id) {
      this[methods](id);
    },
    // 收费逻辑
    gopay() {
      alert("请扫码付费2元后可浏览！！！~");
      this.showModal = true;
    },
    // 跳转详情页
    goDetails(id) {
      this.$router.push({
        path: "/sound/:" + id,
        query: { type: id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.ac2 {
  width: 100%;
  margin-top: 100px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 50%, #f8f9fa 100%);
  min-height: 100vh;

  // 页面头部
  .page-header {
    background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
    color: white;
    padding: 60px 0 40px;
    margin-bottom: 40px;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="film" width="10" height="10" patternUnits="userSpaceOnUse"><rect width="10" height="10" fill="none"/><circle cx="2" cy="2" r="1" fill="%23ffd700" opacity="0.3"/><circle cx="8" cy="8" r="1" fill="%23ffd700" opacity="0.3"/></pattern></defs><rect width="100" height="100" fill="url(%23film)"/></svg>');
      opacity: 0.1;
    }

    .container {
      position: relative;
      z-index: 1;
      text-align: center;
    }

    .page-title {
      font-size: 42px;
      font-weight: bold;
      margin-bottom: 15px;
      color: #ffd700;
      text-shadow: 0 2px 10px rgba(255, 215, 0, 0.3);
    }

    .page-subtitle {
      font-size: 18px;
      opacity: 0.9;
      margin-bottom: 20px;
      letter-spacing: 1px;
    }

    .page-decoration {
      height: 4px;
      background: linear-gradient(90deg, transparent, #ffd700, transparent);
      border-radius: 2px;
      margin: 0 auto;
      width: 100px;
    }
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .content-wrapper {
    display: flex;
    gap: 30px;
    margin-bottom: 60px;

    // 左侧
    .a2-l {
      flex: 1;

      //banner 图片
      .a2-banner {
        width: 100%;
        height: 300px;
        border-radius: 15px;
        overflow: hidden;
        position: relative;
        margin-bottom: 30px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .banner-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, rgba(255, 215, 0, 0.2) 0%, rgba(0, 0, 0, 0.4) 100%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          color: white;
          text-align: center;

          h2 {
            font-size: 32px;
            font-weight: bold;
            margin-bottom: 10px;
            text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.5);
          }

          p {
            font-size: 16px;
            opacity: 0.9;
            letter-spacing: 1px;
          }
        }

        &:hover img {
          transform: scale(1.05);
        }
      }

      // 统计栏
      .stats-bar {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 20px;
        margin-bottom: 30px;

        .stat-item {
          background: white;
          padding: 25px 20px;
          border-radius: 12px;
          text-align: center;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
          border: 1px solid rgba(255, 215, 0, 0.1);
          transition: all 0.3s ease;

          &:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 25px rgba(255, 215, 0, 0.15);
          }

          i {
            font-size: 32px;
            color: #ffd700;
            margin-bottom: 10px;
            display: block;
          }

          .stat-number {
            display: block;
            font-size: 24px;
            font-weight: bold;
            color: #1a1a1a;
            margin-bottom: 5px;
          }

          .stat-label {
            font-size: 14px;
            color: #666;
          }
        }
      }

      // 循环项
      .a2-item {
        margin-bottom: 25px;

        .item-card {
          background: white;
          border-radius: 15px;
          overflow: hidden;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
          border: 1px solid rgba(0, 0, 0, 0.05);
          transition: all 0.3s ease;
          display: flex;

          &:hover {
            transform: translateY(-5px);
            box-shadow: 0 15px 35px rgba(255, 215, 0, 0.15);
            border-color: rgba(255, 215, 0, 0.3);
          }

          // 左侧图片
          .item-img {
            flex: 0 0 280px;
            position: relative;
            overflow: hidden;

            img {
              width: 100%;
              // height: 20px;
              height: 100%;
              object-fit: cover;
              transition: transform 0.3s ease;
            }

            .item-badge {
              position: absolute;
              top: 15px;
              left: 15px;
              display: flex;
              flex-direction: column;
              gap: 8px;

              .premium-tag {
                background: linear-gradient(135deg, #ff6b6b, #ff8e8e);
                color: white;
                padding: 6px 12px;
                border-radius: 15px;
                font-size: 12px;
                font-weight: bold;
                box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);
              }

              .price-tag {
                background: rgba(0, 0, 0, 0.8);
                color: #ffd700;
                padding: 4px 10px;
                border-radius: 12px;
                font-size: 14px;
                font-weight: bold;
              }
            }

            .item-overlay {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background: rgba(0, 0, 0, 0.7);
              display: flex;
              justify-content: center;
              align-items: center;
              opacity: 0;
              transition: opacity 0.3s ease;

              .read-now-btn {
                background: linear-gradient(135deg, #ffd700, #ffed4e);
                color: #000;
                border: none;
                padding: 10px 20px;
                border-radius: 20px;
                font-weight: bold;
                cursor: pointer;
                transition: all 0.3s ease;
              }
            }

            &:hover {
              img {
                transform: scale(1.1);
              }

              .item-overlay {
                opacity: 1;
              }
            }
          }

          // 右侧信息
          .item-info {
            flex: 1;
            padding: 25px;

            // 标题
            .item-title {
              font-size: 20px;
              font-weight: bold;
              color: #1a1a1a;
              margin-bottom: 15px;
              line-height: 1.4;
              cursor: pointer;
              transition: color 0.3s ease;

              &:hover {
                color: #ffd700;
              }
            }

            // 元信息
            .item-meta {
              display: flex;
              gap: 20px;
              margin-bottom: 15px;

              .meta-item {
                display: flex;
                align-items: center;
                gap: 5px;
                font-size: 13px;
                color: #666;

                i {
                  color: #ffd700;
                  font-size: 14px;
                }
              }
            }

            // 简介
            .item-jj {
              font-size: 14px;
              line-height: 1.6;
              color: #666;
              margin-bottom: 20px;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }

            // 操作区域
            .item-actions {
              display: flex;
              justify-content: space-between;
              align-items: center;

              .pay-btn {
                background: linear-gradient(135deg, #ff6b6b, #ff8e8e);
                color: white;
                border: none;
                padding: 10px 25px;
                border-radius: 20px;
                font-weight: bold;
                cursor: pointer;
                transition: all 0.3s ease;
                display: flex;
                align-items: center;
                gap: 8px;
                box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);

                &:hover {
                  transform: translateY(-2px);
                  box-shadow: 0 6px 20px rgba(255, 107, 107, 0.4);
                }
              }

              .action-btns {
                display: flex;
                gap: 20px;

                .action-btn {
                  display: flex;
                  align-items: center;
                  gap: 5px;
                  font-size: 13px;
                  color: #666;
                  cursor: pointer;
                  transition: color 0.3s ease;

                  i {
                    font-size: 14px;
                  }

                  &:hover {
                    color: #ffd700;
                  }
                }
              }
            }
          }
        }
      }

      // 分页控件
      .pagination {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        margin-top: 40px;

        .page-btn {
          background: white;
          border: 1px solid rgba(0, 0, 0, 0.1);
          padding: 10px 15px;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.3s ease;
          font-size: 14px;

          &:hover {
            border-color: #ffd700;
            color: #ffd700;
          }

          &.active {
            background: #ffd700;
            color: #000;
            border-color: #ffd700;
          }

          &.next {
            display: flex;
            align-items: center;
            gap: 5px;
            padding: 10px 20px;
          }
        }
      }
    }

    // 右侧
    .a2-r {
      flex: 0 0 320px;

      .sidebar-card {
        background: white;
        border-radius: 15px;
        padding: 25px;
        margin-bottom: 25px;
        box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
        border: 1px solid rgba(255, 215, 0, 0.1);

        .card-header {
          margin-bottom: 20px;

          .card-title {
            font-size: 18px;
            font-weight: bold;
            color: #1a1a1a;
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 10px;

            i {
              color: #ff6b6b;
            }
          }

          .title-decoration {
            height: 2px;
            background: linear-gradient(90deg, #ff6b6b, transparent);
            border-radius: 1px;
          }
        }

        // 热门文章
        .hot-list {
          .hot-item {
            display: flex;
            align-items: center;
            gap: 15px;
            padding: 15px 0;
            border-bottom: 1px solid rgba(0, 0, 0, 0.05);
            cursor: pointer;
            transition: all 0.3s ease;

            &:last-child {
              border-bottom: none;
            }

            &:hover {
              transform: translateX(5px);

              .hot-title {
                color: #ffd700;
              }
            }

            .hot-rank {
              .rank-number {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 24px;
                height: 24px;
                background: #f8f9fa;
                color: #666;
                border-radius: 6px;
                font-size: 12px;
                font-weight: bold;

                &.top3 {
                  background: #ff6b6b;
                  color: white;
                }
              }
            }

            .hot-content {
              flex: 1;

              .hot-title {
                font-size: 14px;
                font-weight: 500;
                color: #1a1a1a;
                margin-bottom: 5px;
                line-height: 1.4;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                transition: color 0.3s ease;
              }

              .hot-meta {
                .hot-views {
                  font-size: 11px;
                  color: #999;
                  display: flex;
                  align-items: center;
                  gap: 3px;

                  i {
                    color: #ff6b6b;
                  }
                }
              }
            }
          }
        }

        // 标签云
        .tags-cloud {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;

          .tag {
            padding: 6px 12px;
            border-radius: 15px;
            font-size: 12px;
            cursor: pointer;
            transition: all 0.3s ease;
            border: 1px solid transparent;

            &.tag-primary {
              background: rgba(255, 215, 0, 0.1);
              color: #ffd700;
              border-color: rgba(255, 215, 0, 0.3);

              &:hover {
                background: #ffd700;
                color: #000;
              }
            }

            &.tag-secondary {
              background: rgba(107, 114, 255, 0.1);
              color: #6b72ff;
              border-color: rgba(107, 114, 255, 0.3);

              &:hover {
                background: #6b72ff;
                color: white;
              }
            }

            &.tag-success {
              background: rgba(40, 199, 111, 0.1);
              color: #28c76f;
              border-color: rgba(40, 199, 111, 0.3);

              &:hover {
                background: #28c76f;
                color: white;
              }
            }

            &.tag-warning {
              background: rgba(255, 159, 67, 0.1);
              color: #ff9f43;
              border-color: rgba(255, 159, 67, 0.3);

              &:hover {
                background: #ff9f43;
                color: white;
              }
            }

            &.tag-danger {
              background: rgba(255, 107, 107, 0.1);
              color: #ff6b6b;
              border-color: rgba(255, 107, 107, 0.3);

              &:hover {
                background: #ff6b6b;
                color: white;
              }
            }
          }
        }

        // 订阅卡片
        &.subscribe-card {
          background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
          color: white;
          text-align: center;

          .subscribe-content {
            .subscribe-icon {
              font-size: 48px;
              color: #ffd700;
              margin-bottom: 15px;
              display: block;
            }

            .subscribe-title {
              font-size: 18px;
              font-weight: bold;
              margin-bottom: 10px;
              color: #ffd700;
            }

            .subscribe-desc {
              font-size: 14px;
              opacity: 0.8;
              margin-bottom: 20px;
              line-height: 1.5;
            }

            .subscribe-btn {
              background: linear-gradient(135deg, #ffd700, #ffed4e);
              color: #000;
              border: none;
              padding: 12px 25px;
              border-radius: 25px;
              font-weight: bold;
              cursor: pointer;
              transition: all 0.3s ease;
              display: flex;
              align-items: center;
              gap: 8px;
              margin: 0 auto;
              box-shadow: 0 4px 15px rgba(255, 215, 0, 0.3);

              &:hover {
                transform: translateY(-2px);
                box-shadow: 0 6px 20px rgba(255, 215, 0, 0.4);
              }
            }
          }
        }
      }
    }
  }
}

// 支付弹窗样式
.payment-content {
  text-align: center;
  padding: 20px;

  .payment-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-bottom: 20px;

    .payment-lock {
      font-size: 24px;
      color: #ffd700;
    }

    h3 {
      font-size: 20px;
      font-weight: bold;
      color: #1a1a1a;
      margin: 0;
    }
  }

  .payment-amount {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f8f9fa;
    padding: 15px 20px;
    border-radius: 10px;
    margin-bottom: 20px;

    .amount-label {
      font-size: 14px;
      color: #666;
    }

    .amount-value {
      font-size: 24px;
      font-weight: bold;
      color: #ff6b6b;
    }
  }

  .payment-qr {
    width: 200px;
    height: 200px;
    margin: 0 auto 20px;
    border: 2px solid #ffd700;
    border-radius: 10px;
    padding: 10px;
  }

  .payment-methods {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;

    .method-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      padding: 15px;
      border: 2px solid #e9ecef;
      border-radius: 10px;
      cursor: pointer;
      transition: all 0.3s ease;

      &.active {
        border-color: #ffd700;
        background: rgba(255, 215, 0, 0.05);
      }

      i {
        font-size: 24px;
        color: #666;
      }

      span {
        font-size: 14px;
        font-weight: 500;
      }
    }
  }

  .payment-tip {
    font-size: 14px;
    color: #666;
    margin: 0;
  }
}

// 响应式调整
@media (max-width: 1024px) {
  .content-wrapper {
    flex-direction: column;
  }

  .a2-r {
    flex: 1 !important;
  }
}

@media (max-width: 768px) {
  .item-card {
    flex-direction: column !important;
  }

  .item-img {
    flex: 1 !important;
    height: 200px !important;
  }

  .stats-bar {
    grid-template-columns: 1fr !important;
  }
}
</style>